export const defaultCountry = 'de';
export const defaultLanguage = 'en';
export const defaultLocale = 'en_de';
